export default {
  routes: (state) => state.routes
}
